
export interface ICreateOrderRequest {
    vin: string;
    packageSku: string;
}
